module.exports = "/assets/data/fec552785b388f6c15163bb08e50cf70-RM3.data.json";